const BlackTip: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.63375 0.5C6.01865 -0.166667 6.9809 -0.166667 7.3658 0.5L12.1289 8.75H0.870605L5.63375 0.5Z"
        fill="#181717"
      />
    </svg>
  );
};

export default BlackTip;
